import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CircularProgress from '@mui/material/CircularProgress';
import Portal from '@mui/base/Portal';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

var vertical='top',horizontal='center';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 16,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

export default function CustomizedMenus(props) {
    const [severityAlert, setSeverityAlert] = React.useState("error");
    const [showAlert, setShowAlert] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [loader, setLoader] = React.useState(false);

    const statusList = ['Draft','Sent','Approved','Paid','Cancelled','Refund'];    
    const [selectedStatus, setSelectedStatus] = React.useState("");
    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    function switchStatus(val){
        setLoader(true);
        setSelectedStatus(val);
        saveData();
    }

    // React.useEffect(() => {
    //   if(open){ // only on open state
    //     setSelectedStatus(props.dataObj.status);      
    //   }  
      
    // }, [props.dataObj, open]);

	function saveData(){

		if(selectedStatus){ 
      let axiosHeader = {
        headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
      };

      

      const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('invoiceId', props.dataObj.autoId);
      }

      if(selectedStatus && selectedStatus.length>0){
        data.append('fieldName', 'status');
        data.append('status', selectedStatus);
      }      
      setLoader(true);
			axios.post(API_URL+'/crm-update-field-invoices', data, axiosHeader)
			.then((response) => {
        setLoader(false);
        setAnchorEl(null);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Invoice status has been updated.");
					return false;

				}else if(response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';

				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Invoice could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				  setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  function hideAlert(){
		setShowAlert(false);
	}

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}        
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        color="inherit"
        size='small'
        style={{textTransform:'none', marginLeft: -6}}
      >
        {selectedStatus?selectedStatus:props.title}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >

        {(statusList && statusList.length>0)?statusList.map((row)=>(          
          (selectedStatus===row)?
          <MenuItem disableRipple key={'lib'+row} onClick={()=>{switchStatus(row)}} sx={{backgroundColor:'#c2e4fc',color:'#1f407a'}}>
            <ListItemIcon>{(loader && selectedStatus===row)?<CircularProgress size={25} />:<RadioButtonCheckedIcon />}</ListItemIcon>
            <ListItemText primary={<div onClick={()=>{switchStatus(row)}} >{row}</div>}  size='small' variant='contained' />
          </MenuItem>
          :
          <MenuItem disableRipple key={'lib'+row} onClick={()=>{switchStatus(row)}} >
            <ListItemIcon>{(loader && selectedStatus===row)?<CircularProgress size={25} />:<RadioButtonUncheckedIcon />}</ListItemIcon>
            <ListItemText primary={<div onClick={()=>{switchStatus(row)}} >{row}</div>} size='small' variant='contained' />
          </MenuItem>
        )):null}
       
      </StyledMenu>

      <Portal>
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>
      </Portal>

    </div>
  );
}
